import { combineReducers } from 'redux'
import loginForm from './loginForm'

const formsReducer = combineReducers({
  loginForm
})

export default formsReducer
